import React from "react";
import { Button } from "@/components/ui";
import { CheckCircle2Icon, ArrowLeftIcon } from "lucide-react";

interface SuccessStateProps {
  message: string;
  onBack: () => void;
}

export function SuccessState({ message, onBack }: SuccessStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-6 text-center h-[400px]">
      <div className="size-16 rounded-full bg-emerald-50 flex items-center justify-center mb-6">
        <CheckCircle2Icon className="size-10 text-emerald-500" />
      </div>
      <h3 className="text-lg font-bold text-slate-900 mb-2">Update Successful</h3>
      <p className="text-sm text-slate-500 max-w-xs mb-8">{message}</p>
      <Button onClick={onBack} variant="outline" className="gap-2">
        <ArrowLeftIcon className="h-4 w-4" />
        Back to Post Details
      </Button>
    </div>
  );
}
